import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  return <section className="bg-white py-20 px-4" data-id="element-143">
      <div className="max-w-4xl mx-auto" data-id="element-144">
        <FadeIn data-id="element-145">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-10" data-id="element-146">
            El problema real:{' '}
            <span className="italic text-terracotta" data-id="element-147">Inflamación Crónica</span>
          </h2>

          <div className="prose prose-lg md:prose-xl text-brown-body mx-auto" data-id="element-148">
            <p className="mb-6" data-id="element-149">
              La mayoría de las mujeres en Estados Unidos viven en un estado de
              "inflamación crónica de bajo grado". Tu cuerpo ha encendido el
              interruptor de cortisol y ha decidido que, para protegerte del
              estrés, debe retener cada gramo de líquido y gas posible.
            </p>
            <p className="mb-6" data-id="element-150">
              Por eso, aunque comas ensaladas o vayas al gimnasio, la barriga no
              baja. De hecho, a veces baja por la mañana pero para las 4 de la
              tarde pareces tener varios meses de embarazo.
            </p>
            <p className="font-medium text-brown-dark text-xl text-center mt-10 p-6 bg-cream rounded-2xl" data-id="element-151">
              Estás cansada de sentirte incómoda en tu propia piel y de que tu
              rendimiento en el trabajo y con tu familia no sea el mismo.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}